/**
 * PrintButton – reusable print / export-to-PDF trigger button.
 *
 * Props:
 *   onClick    – the handlePrint callback from usePrint()
 *   label      – button text (default "Export PDF")
 *   labelAr    – Arabic label (default "تصدير PDF")
 *   isAr       – whether the UI is in Arabic mode
 *   className  – extra Tailwind classes
 */

import { Printer } from 'lucide-react';

interface PrintButtonProps {
  onClick: () => void;
  label?: string;
  labelAr?: string;
  isAr?: boolean;
  className?: string;
}

export const PrintButton = ({
  onClick,
  label = 'Export PDF',
  labelAr = 'تصدير PDF',
  isAr = false,
  className = '',
}: PrintButtonProps) => (
  <button
    onClick={onClick}
    className={`no-print inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-colors shadow-sm ${className}`}
    title={isAr ? labelAr : label}
  >
    <Printer className="h-4 w-4" />
    <span>{isAr ? labelAr : label}</span>
  </button>
);

export default PrintButton;
